import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/Home";
import Footer from "./Components/Footer/Footer";
import About from "./Components/About/About";
import FlightResult from "./Components/FlightResult/FlightResult";
import Contact from "./Components/Contact/Contact";
import DestinationOffer from "./Components/DestinationOffer/DestinationOffer";
import DestinationDetails from "./Components/DestinationOffer/DestinationDetails";
import Destination from "./Components/Destination/Destination";
import Flight from "./Components/Flight/Flight";
import FlightDetails from "./Components/Flight/FlightDetails";
import SignInForm from "./Components/signin/SignInForm";
import ProtectedRoute from "./Components/comman/ProtectedRoute";
import FlightUpload from "./Components/flight-upload/FlightUpload";
import NotFound from "./Components/NotFound/NotFound";
import PrivacyPolicy from "./Components/PrivacyAndPolicy/PrivacyAndPolicy";
import TermsAndConditions from "./Components/TermsAndConditions/TermsAndConditions";
import FlightToDeal from "./Components/Flight/FlightToDeals";
import Booking from "./Components/Booking/Booking";
import Chat from "./Components/Chatbox/Chat";
import CookieConsent from "./Components/CookieConsent";
import { initAnalytics } from "./utils/analytics";

/* ===============================
   Scroll + Page Tracking
================================ */

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    const path = location.pathname;
    let pageName = "Home";

    // ===== ROUTE MAPPING =====

    if (path === "/") pageName = "Home";
    else if (path === "/aboutus") pageName = "About";
    else if (path === "/contactus") pageName = "Contact";
    else if (path === "/privacy-policy") pageName = "PrivacyPolicy";
    else if (path === "/terms&conditions") pageName = "Terms";
    else if (path === "/flight") pageName = "Flight";
    else if (path.startsWith("/flight/")) pageName = "FlightDetails";
    else if (path.startsWith("/destination/")) {
      const parts = path.split("/");
      const country = parts[2];
      const destination = parts[3];
      pageName = `Destination:${country}:${destination}`;
    }
    else if (path === "/holidays") pageName = "Holidays";
    else if (path.startsWith("/holidays/")) pageName = "HolidayDetails";
    else if (path === "/signin") pageName = "SignIn";
    else if (path === "/flight-result") pageName = "FlightResult";
    else pageName = "Other";

    // 🔥 Run analytics on every route change
    initAnalytics(pageName);

  }, [location]);

  return null;
}

/* ===============================
   Main App
================================ */

function App() {
  return (
    <Router>
      <Navbar />
      <ScrollToTop />
      <CookieConsent />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<About />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms&conditions" element={<TermsAndConditions />} />
        <Route path="/flight" element={<Flight />} />
        <Route path="/flight/:id" element={<FlightDetails />} />
        <Route
          path="/destination/:countryId/:destinationId"
          element={<FlightToDeal />}
        />
        <Route path="/flight-result" element={<FlightResult />} />
        <Route path="/holidays" element={<Destination />} />
        <Route path="/holidays/:id" element={<DestinationDetails />} />
        <Route path="/signin" element={<SignInForm />} />

        <Route
          path="/upload-flight"
          element={
            <ProtectedRoute>
              <FlightUpload />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>

      <Chat />
      <Footer />
    </Router>
  );
}

export default App;
